import React from 'react'
import {useSupplierFormItem} from "../providers/SupplierFormItemProvider";
import {FormInputComponent} from "../../../components/form/Form";

const SupplierAwardForm = (props) => {

    const {
        profileItem,
        profileIndex,
        onModelChange,
        refresh,
        isEditing,
        yearOptions
    } = useSupplierFormItem()

    return (
        <div className="flex flex-col">
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-5/12">
                    <FormInputComponent
                        fieldName="name"
                        value={profileItem.name || ''}
                        type={'text'}
                        label={TB.trans('talent.award_form.award_name_label')}
                        maxLength={255}
                        required={true}
                        placeholder={TB.trans('talent.award_form.award_name_placeholder')}
                        style={styles.field}
                    />
                </div>
            </div>
            {(isEditing || profileItem.url || profileItem.year) && (

                <div className="field-section flex-row">
                    {(isEditing || profileItem.url) && (
                        <div className="field px-3.5 basis-5/12">
                            <FormInputComponent
                                fieldName="url"
                                value={profileItem.url || ''}
                                label={TB.trans('talent.award_form.award_url_label')}
                                placeholder={TB.trans('talent.award_form.award_url_placeholder')}
                                type="url"
                                maxLength={255}
                                required={false}
                                style={styles.field}
                            />
                        </div>
                    )}
                    {(isEditing || profileItem.year) && (
                        <div className="field px-3.5 basis-5/12">
                            <FormInputComponent
                                fieldName="year"
                                value={profileItem.year || ''}
                                label={TB.trans('talent.award_form.year_label')}
                                placeholder={TB.trans('talent.award_form.year_placeholder')}
                                type={'select'}
                                required={true}
                                options={yearOptions}
                                style={styles.field}
                            />
                        </div>
                    )}

                </div>

            )}
            {(isEditing || profileItem.logo_path) && (
                <div className="field-section flex-row">
                    <div className="field px-3.5 basis-8/12">
                        <FormInputComponent
                            fieldName="logo_path"
                            value={profileItem.logo_path || ''}
                            label={TB.trans('talent.award_form.award_logo_label')}
                            type="pixie"
                            ratio="1:1"
                            required={false}
                            style={styles.field}
                        />
                    </div>
                </div>
            )}

            {(isEditing || profileItem.description) && (
                <div className="field-section flex-row">
                    <div className="field px-3.5 basis-8/12">
                        <FormInputComponent
                            fieldName="description"
                            value={profileItem.description || ''}
                            label={TB.trans('talent.award_form.summary_paragraph_label')}
                            placeholder={TB.trans('talent.award_form.summary_paragraph_placeholder')}
                            type={'editor'}
                            required={false}
                            style={styles.field}
                            maxLength={10000}
                            rows={10}
                            validation={{
                                rules: {maxLength: 10000},
                                errors: {
                                    maxLength: TB.trans('validation.max.string', {
                                        'attribute': 'description',
                                        'max': 10000
                                    })
                                }
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default SupplierAwardForm;

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};